import React from 'react'

import { Outlet } from "react-router-dom";


import Navigation from '../Components/Navigation'
import Footer from '../Components/Footer'


export default function Layout() {
  return (
    <>
        <Navigation></Navigation>
        <Outlet/>
        <Footer></Footer>
    </>
  )
}
